export default __webpack_public_path__ + "sleeping-illustration.webp";